import gql from "graphql-tag";

const queryGetAllDepartment = gql`
  query($status: String, $limit: Int, $page: Int, $query: String) {
    getAllDepartment(
      status: $status
      query: $query
      paging: { limit: $limit, page: $page }
    ) {
      id
      name
      updatedAt
      createdAt
      status
      parentId
      managers {
        id
        fullname
        username
        email
      }
      createHelpers {
        id
        fullname
        username
        email
      }
    }
  }
`;

const queryGetDepartment = gql`
  query($id: ID!) {
    getDepartment(id: $id) {
      id
      name
      updatedAt
      createdAt
      status
      parentId
      canShowOnDocument
      hrReporters {
        id
        fullname
        username
        email
      }
      managers {
        id
        fullname
        username
        email
      }
      createHelpers {
        id
        fullname
        username
        email
      }
      supervisors {
        id
        fullname
        username
        email
      }

      author {
        id
        fullname
      }
      parent {
        id
        name
      }
      workShifts {
        id
        title
        code
        description
        dayInWeeks
        startTime
        endTime
        duration
        coefficient
        isOvertime
        createdAt
        updatedAt
      }
    }
  }
`;

const getListDepartmentParent = gql`
  query($status: String, $limit: Int, $page: Int, $query: String) {
    getListDepartmentParent(
      status: $status
      query: $query
      paging: { limit: $limit, page: $page }
    ) {
      id
      name
      status
    }
  }
`;

const getAllEmployee = gql`
  query(
    $limit: Int
    $page: Int
    $query: String
    $gender: String
    $positionId: ID
    $departmentIds: [ID!]
  ) {
    getAllEmployee(
      paging: { limit: $limit, page: $page }

      query: $query

      filter: {
        gender: $gender
        positionId: $positionId
        departmentIds: $departmentIds
      }
    ) {
      id
      code
      email
      fullname
      birthday
      gender
      concurrentPositions {
        id
      }
      position {
        id
        name
      }
      department {
        id
        name
      }
      user {
        id
        fullname
      }
    }
  }
`;

export default {
  queryGetAllDepartment,
  queryGetDepartment,
  getListDepartmentParent,
  getAllEmployee,
};
